import { Action } from '@ngrx/store';
import { CustomerUser } from '@model';

export enum CustomerUsersActionTypes {
  CustomerUsersLoadData = '[CustomerUsers] Load data',
  CustomerUsersLoadSuccess = '[CustomerUsers] Load success',
  CustomerUsersLoadFail = '[CustomerUsers] Load fail',

  UpdateCustomerUser = '[CustomerUser] Update',
  UpdateCustomerUserSuccess = '[CustomerUser] Update success',
  UpdateCustomerUserFail = '[CustomerUser] Update fail',

  CreateCustomerUser = '[CustomerUser] Create',
  CreateCustomerUserSuccess = '[CustomerUser] Create success',
  CreateCustomerUserFail = '[CustomerUser] Create fail',

  BulkUpdateCustomerUser = '[CustomerUser] Bulk update',
  BulkUpdateCustomerUserSuccess = '[CustomerUser] Bulk update success',
  BulkUpdateCustomerUserFail = '[CustomerUser] Bulk update fail',

  CustomerUsersSelect = '[CustomerUsers] Select',

  CustomerUserRemove = '[CustomerUsers] Remove',
  CustomerUserRemoveSuccess = '[CustomerUsers] Remove success',
  CustomerUserRemoveFail = '[CustomerUsers] Remove fail',

  BulkRemoveCustomerUser = '[CustomerUsers] Bulk remove',
  BulkRemoveCustomerUserSuccess = '[CustomerUsers] Bulk remove success',
  BulkRemoveCustomerUserFail = '[CustomerUsers] Bulk remove fail',

  SetPrimaryCustomerUser = '[CustomerUsers] Set primary',
  SetPrimaryCustomerUserSuccess = '[CustomerUsers] Set primary success',
  SetPrimaryCustomerUserFail = '[CustomerUsers] Set primary fail',
  CustomerUserDisplayTabChanged = '[CustomerUsers] Changed Tab in display'
}

export class CustomerUsersLoadData implements Action {
  readonly type = CustomerUsersActionTypes.CustomerUsersLoadData;
  constructor(public payload: string) {}
}
export class CustomerUsersLoadSuccess implements Action {
  readonly type = CustomerUsersActionTypes.CustomerUsersLoadSuccess;
  constructor(public payload: CustomerUser[]) {}
}
export class CustomerUsersLoadFail implements Action {
  readonly type = CustomerUsersActionTypes.CustomerUsersLoadFail;
  constructor(public payload: any) {}
}
export class UpdateCustomerUser implements Action {
  readonly type = CustomerUsersActionTypes.UpdateCustomerUser;
  constructor(public payload: CustomerUser) {}
}
export class UpdateCustomerUserSuccess implements Action {
  readonly type = CustomerUsersActionTypes.UpdateCustomerUserSuccess;
  constructor(public payload: CustomerUser) {}
}
export class UpdateCustomerUserFail implements Action {
  readonly type = CustomerUsersActionTypes.UpdateCustomerUserFail;
  constructor(public payload: any) {}
}
export class CreateCustomerUser implements Action {
  readonly type = CustomerUsersActionTypes.CreateCustomerUser;
  constructor(public payload: CustomerUser) {}
}
export class CreateCustomerUserSuccess implements Action {
  readonly type = CustomerUsersActionTypes.CreateCustomerUserSuccess;
  constructor(public payload: CustomerUser) {}
}
export class CreateCustomerUserFail implements Action {
  readonly type = CustomerUsersActionTypes.CreateCustomerUserFail;
  constructor(public payload: any) {}
}
export class BulkUpdateCustomerUser implements Action {
  readonly type = CustomerUsersActionTypes.BulkUpdateCustomerUser;
  constructor(public payload: CustomerUser[]) {}
}
export class BulkUpdateCustomerUserSuccess implements Action {
  readonly type = CustomerUsersActionTypes.BulkUpdateCustomerUserSuccess;
  constructor(public payload: boolean) {}
}
export class BulkUpdateCustomerUserFail implements Action {
  readonly type = CustomerUsersActionTypes.BulkUpdateCustomerUserFail;
  constructor(public payload: any) {}
}
export class CustomerUsersSelect implements Action {
  readonly type = CustomerUsersActionTypes.CustomerUsersSelect;
  constructor(public payload: CustomerUser) {}
}
export class CustomerUserRemove implements Action {
  readonly type = CustomerUsersActionTypes.CustomerUserRemove;
  constructor(public payload: CustomerUser) {}
}
export class CustomerUserRemoveSuccess implements Action {
  readonly type = CustomerUsersActionTypes.CustomerUserRemoveSuccess;
  constructor(public payload: CustomerUser) {}
}
export class CustomerUserRemoveFail implements Action {
  readonly type = CustomerUsersActionTypes.CustomerUserRemoveFail;
  constructor(public payload: any) {}
}
export class BulkRemoveCustomerUser implements Action {
  readonly type = CustomerUsersActionTypes.BulkRemoveCustomerUser;
  constructor(public payload: CustomerUser[]) {}
}
export class BulkRemoveCustomerUserSuccess implements Action {
  readonly type = CustomerUsersActionTypes.BulkRemoveCustomerUserSuccess;
  constructor(public payload: boolean) {}
}
export class BulkRemoveCustomerUserFail implements Action {
  readonly type = CustomerUsersActionTypes.BulkRemoveCustomerUserFail;
  constructor(public payload: any) {}
}

export class SetPrimaryCustomerUser implements Action {
  readonly type = CustomerUsersActionTypes.SetPrimaryCustomerUser;
  constructor(public payload: CustomerUser) {}
}
export class SetPrimaryCustomerUserSuccess implements Action {
  readonly type = CustomerUsersActionTypes.SetPrimaryCustomerUserSuccess;
  constructor(public payload: CustomerUser) {}
}
export class SetPrimaryCustomerUserFail implements Action {
  readonly type = CustomerUsersActionTypes.SetPrimaryCustomerUserFail;
  constructor(public payload: any) {}
}
export class CustomerUserDisplayTabChanged implements Action {
  readonly type = CustomerUsersActionTypes.CustomerUserDisplayTabChanged;
  constructor(public payload: number) {}
}


export type CustomerUsersActions =
  | CustomerUsersLoadData
  | CustomerUsersLoadSuccess
  | CustomerUsersLoadFail
  | CustomerUsersSelect
  | UpdateCustomerUser
  | UpdateCustomerUserSuccess
  | UpdateCustomerUserFail
  | CreateCustomerUser
  | CreateCustomerUserSuccess
  | CreateCustomerUserFail
  | BulkUpdateCustomerUser
  | BulkUpdateCustomerUserSuccess
  | BulkUpdateCustomerUserFail
  | CustomerUserRemove
  | CustomerUserRemoveSuccess
  | CustomerUserRemoveFail
  | BulkRemoveCustomerUser
  | BulkRemoveCustomerUserSuccess
  | BulkRemoveCustomerUserFail
  | SetPrimaryCustomerUser
  | SetPrimaryCustomerUserSuccess
  | SetPrimaryCustomerUserFail
  | CustomerUserDisplayTabChanged;
